module.exports = __webpack_public_path__ + "static/media/2023_2.243cf8aa.png";